/*
 * Model and reqres' for responses
 */

define(["backbone"], function (Backbone) {
  var ResponseEditorModalModel = {};

  ResponseEditorModalModel.responseEditorModal = Backbone.Model.extend({
    defaults: {
      touchPointId: "",
      localeId: "",
      response: "",
      conversationVariable: "",
    },
  });

  return ResponseEditorModalModel;
});
